// Changing avatars in a world remounts the local player (FixedRetargetedAvatar
// is keyed by its model URL). Without help the new body would start over at
// the spawn point with the camera reset. The outgoing avatar leaves its pose
// here as it unmounts; the incoming one, when told it is a swap (carryPose),
// picks it up: same spot, same facing, same camera angle, and — if it was
// sitting — walks itself back onto the same seat (re-measured for its own
// hip height).

export interface CarriedSeat {
  x: number; z: number; yaw: number; surface: number; minY: number; maxY: number; perch: number; floor?: number; fit?: 'chair';
}

export interface CarriedPose {
  position: [number, number, number];
  yaw: number;
  camera: { x: number; y: number };
  fpYaw: number;
  fpPitch: number;
  seat: CarriedSeat | null;
  at: number;
}

let last: CarriedPose | null = null;

export function leaveLocalPose(pose: Omit<CarriedPose, 'at'>) {
  last = { ...pose, at: Date.now() };
}

/** The pose a just-unmounted local avatar left, if it is fresh. One use. */
export function takeLocalPose(maxAgeMs = 5000): CarriedPose | null {
  const p = last;
  last = null;
  return p && Date.now() - p.at <= maxAgeMs ? p : null;
}
